/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var ConfigurazioneSoglieCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    configurazioneSoglieSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.configurazioneSoglieSrvc = configurazioneSoglieSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};
    this.gridOptions2 = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.filiali = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
        self.spinner.showSpinner = true;
        self.configurazioneSoglieSrvc
          .promiseRecuperaSoglie()
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              self.filiali = response.data.result;

              self.gridOptions2 = {
                enableSorting: true,
                enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
                enableHorizontalScrollbar:
                  self.uiGridConstants.scrollbars.NEVER,
                columnDefs: [
                  { name: 'filiale', field: 'filiale' },
                  { name: 'descrizione', field: 'descrizione' },
                  {
                    name: 'soglia',
                    field: 'value',
                    enableCellEdit: false,
                    cellTemplate:
                      '<div style="margin:2px;height:100px;">\
                    <form name="inputForm">\
                    <input type="text" ng-model="MODEL_COL_FIELD" style="height: 25px;padding: 2px" cc-numeric>\
                    </form></div>'
                  }
                ],
                data: self.filiali.sogliaList
              };

              self.tableHeight = self.filiali.sogliaList.length * 30 + 40;

              self.stiliTabella = {
                height: self.tableHeight + 'px',
                width: '50%'
              };

              // Configurazione tabella
              self.gridOptions = {
                enableSorting: true,
                enableColumnMenus: false,
                enableGrouping: false,
                multiSelect: false,
                showHeader: true,
                enableRowHeaderSelection: false,
                enableRowSelection: true,
                // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
                showGridFooter: false,
                enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
                enableHorizontalScrollbar:
                  self.uiGridConstants.scrollbars.NEVER,
                enableColumnResizing: true,
                enableCellEditing: false,
                columnDefs: [
                  {
                    displayName: 'Filiale',
                    field: 'filiale',
                    width: '25%',
                    name: 'filiale',
                    enableCellEdit: false
                  },
                  {
                    displayName: 'Descrizione',
                    field: 'descrizione',
                    width: '50%',
                    name: 'descrizione',
                    enableCellEdit: false
                  },
                  {
                    displayName: 'Soglia',
                    field: 'value',
                    width: '25%',
                    name: 'soglia',
                    enableCellEdit: true,
                    enableCellEditOnFocus: true
                    // cellTemplate: '<input> {{row.entity.value}}</input>'
                  }
                ],
                data: self.filiali.sogliaList,
                onRegisterApi: function(gridApi) {
                  //   self.gridApi = gridApi;
                  //   self.gridApi.grid.modifyRows(self.gridOptions.data);
                  //   // Se era già stato salvato il conto corrente lo recupero e lo seleziono
                  //   if (
                  //     self.propostaTelepassSrvc.datiPratica &&
                  //     self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  //   ) {
                  //     angular.forEach(self.contiCorrenti, function(conto, index) {
                  //       if (
                  //         conto.numeroRapporto ===
                  //         self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  //       ) {
                  //         self.gridApi.selection.selectRow(self.contiCorrenti[index]);
                  //         self.contoSelezionato = self.contiCorrenti[index];
                  //       }
                  //     });
                  //   }
                  //   gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                  //     self.selezionaConto(row);
                  //   });
                }
              };
            },
            function(reason) {
              if (self.messaggiFctr.processaResponse(reason)) {
                self.spinner.showSpinner = false;
              }
            }
          )
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /**
     * @ngdoc method
     * @name salvaSoglie
     * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieCmpt
     * @description Esegue le chiamate per salvare le soglie.
     */
    this.salvaSoglie = function(soglie) {
      self.spinner.showSpinner = true;

      self.configurazioneSoglieSrvc
        .promiseSalvaSoglie(soglie)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            if (response.data.result) {
              // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
              self.filiali = response.data.result;
              self.init();
            }
          },
          function(error) {
            if (self.messaggiFctr.processaResponse(error)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  ConfigurazioneSoglieCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsConfigurazioneSoglieSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglie.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var configurazioneSoglieComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: ConfigurazioneSoglieCtrl,
    controllerAs: 'configurazioneSoglieCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('configurazioneSoglie', configurazioneSoglieComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglie.cmpt.js
// module id = 9
// module chunks = 0